BatchGeoStore.addReducer("Generator", function (state, action) {
  state = state || {
    dataChanged: false,
    focusedElsewhere: false,
  };

  switch (action.type) {
    case "GENERATOR_FOCUSED_ELSEWHERE":
      return _.merge({}, state, { focusedElsewhere: true });

    case "GENERATOR_DATA_CHANGED":
      return _.merge({}, state, { dataChanged: true });

    case "GENERATOR_DATA_RESET":
      return _.merge({}, state, { dataChanged: false });

    default:
      return state;
  }
});
